import { ReactNode } from 'react'

export type NotificationVariant = 'info' | 'success' | 'warning' | 'error'

export interface NotificationType {
  id: string
  variant: NotificationVariant
  title: ReactNode | string
  content?: ReactNode | string
  timestamp?: Date | string
  duration?: number
  closable?: boolean
  action?: ReactNode
  createdAt: number
}

export interface NotificationTheme {
  gradient: string
  iconColor: string
}

export const NOTIFICATION_THEMES: Record<NotificationVariant, NotificationTheme> = {
  info: {
    gradient: 'linear-gradient(180deg, rgb(var(--color-highlight) / 0.16) 0%, transparent 100%)',
    iconColor: 'rgb(var(--color-highlight))',
  },
  success: {
    gradient: 'linear-gradient(180deg, rgb(var(--color-success) / 0.16) 0%, transparent 100%)',
    iconColor: 'rgb(var(--color-success))',
  },
  warning: {
    gradient: 'linear-gradient(180deg, rgb(var(--color-warning) / 0.16) 0%, transparent 100%)',
    iconColor: 'rgb(var(--color-warning))',
  },
  error: {
    gradient: 'linear-gradient(180deg, rgb(var(--color-error) / 0.16) 0%, transparent 100%)',
    iconColor: 'rgb(var(--color-error))',
  },
}

// Legacy MessageType for backward compatibility
export interface MessageType {
  id: string
  type: 'default' | 'error' | 'success'
  content: ReactNode | string
  duration?: number
  action?: ReactNode | string
}
